import React,{Component} from 'react';
import Notification from './Notification';

import logo from './icon.png';
class LoginView extends Component{

  constructor(props){
    super(props);
    this.state = {user:{username:"",password:""}};
    this.updateInputValue = this.updateInputValue.bind(this);
    this.doLogin = this.doLogin.bind(this);
  }
  updateInputValue(evt) {
    let inputName =  evt.target.name;

    let user = this.state.user;
    user[inputName]= evt.target.value;
    this.setState({user:user});

   }
   doLogin(){
     this.props.doLogin(this.state.user);
   }


  render(){
    return(

      <div className="addWorkerView">
         <img src={logo}/>
<h1>Kirjaudu sisään</h1>
        <form>
          <label htmlFor="username" ><span>Käyttäjätunnus</span><input type="text"  name="username"  value={this.state.username} onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="password" ><span>Salasana</span><input type="password"   value={this.state.user.password} name="password" onChange={evt => this.updateInputValue(evt)} /></label>
           <button type="button" className="btnClose" onClick={this.doLogin}>Kirjaudu sisään</button>
        </form>
    </div>
)
}
}
export default LoginView;
